import React from "react";
import { useDispatch } from "react-redux";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { cleanSearchingRegionsPaginated, regionCleanSearchText, regionSetSearchText, startSearchingRegionsPaginated } from "../../app/actions/catalogRegionActions";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackRegion = ({ searchText, setSearchText, itemsPerPage }) => {
    debugLogPages(":: SearchBackRegion");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchRegions", event: "SearchRegions-Clicked", search: event.target.value });

      dispatch(regionSetSearchText(event.target.value));

      dispatch(startSearchingRegionsPaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingRegionsPaginated());

      dispatch(regionCleanSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackRegion;
